import { AiOutlineCheck, AiOutlineLoading3Quarters } from "react-icons/ai";

const BookSubmissionProgress = ({ steps, currentStep }) => {
	if (!currentStep || !steps?.length) {
		return null;
	}

	const currentIndex = steps.findIndex((step) => step.key === currentStep);

	return (
		<div className="rounded-lg border border-akgreen/30 bg-akgreen/5 p-4 space-y-3">
			<p className="text-sm font-semibold text-gray-800">Submitting your book</p>
			<ol className="space-y-2">
				{steps.map((step, index) => {
					const isComplete = currentIndex > index;
					const isCurrent = step.key === currentStep;
					const isPending = currentIndex < index;

					return (
						<li key={step.key} className="flex items-center gap-3 text-sm">
							<span
								className={`flex h-6 w-6 items-center justify-center rounded-full ${
									isComplete
										? "bg-akgreenest text-white"
										: isCurrent
										? "bg-white text-akgreenest border-2 border-akgreenest"
										: "bg-gray-100 text-gray-400 border border-gray-200"
								}`}
							>
								{isComplete ? (
									<AiOutlineCheck size={14} />
								) : isCurrent ? (
									<AiOutlineLoading3Quarters size={14} className="animate-spin" />
								) : (
									<span className="text-xs font-medium">{index + 1}</span>
								)}
							</span>
							<span
								className={
									isPending ? "text-gray-400" : "text-gray-700 font-medium"
								}
							>
								{step.label}
								{isCurrent ? "…" : ""}
							</span>
						</li>
					);
				})}
			</ol>
		</div>
	);
};

export default BookSubmissionProgress;
